import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { Fragment, useContext } from 'react';

import { SearchTable } from './SearchTable';
import { ApplicationContext } from '../../../../../shared/source/context/context';
import { MainHeadlineSubPage } from '../../../design/components/Typography';

import type { FunctionComponent } from 'react';

const Headline: FunctionComponent = () => {
    const { translate } = useContext(ApplicationContext);

    const globalSearchHeadline = translate('pages.global-search.search-headline');

    return (
        <Grid alignContent="center" container={true} sx={{ pb: 3, pt: 6 }}>
            <Container>
                <MainHeadlineSubPage>{globalSearchHeadline}</MainHeadlineSubPage>
            </Container>
        </Grid>
    );
};

export const GlobalSearchPage: FunctionComponent = () => (
    <Fragment>
        <Headline />
        <Container>
            <SearchTable />
        </Container>
    </Fragment>
);
